import { render, staticRenderFns } from "./orderPendingWX.vue?vue&type=template&id=57f8f44a&scoped=true&"
import script from "./orderPendingWX.vue?vue&type=script&lang=js&"
export * from "./orderPendingWX.vue?vue&type=script&lang=js&"
import style0 from "./orderPendingWX.vue?vue&type=style&index=0&id=57f8f44a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f8f44a",
  null
  
)

export default component.exports